// Full-page redirect to the Dodo hosted checkout. We record that a checkout was
// initiated so the payment-return handler can distinguish "came back with
// ?payment=success" from "came back without any outcome" (ambiguous/failed —
// there is no ?payment=failed contract from the backend).
export const CHECKOUT_PENDING_KEY = "checkoutPending";

export const redirectToCheckout = (authorizationUrl) => {
  if (!authorizationUrl) return;
  try {
    localStorage.setItem(CHECKOUT_PENDING_KEY, "1");
  } catch (e) {
    /* ignore storage errors */
  }
  window.location.href = authorizationUrl;
};
